import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, change, touch } from 'redux-form';
import { crmValidator } from 'helpers';
import lodash from 'lodash';

import moment from "moment";

// material-ui components
import withStyles from "@material-ui/core/styles/withStyles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import CustomSelect from "components/CustomSelect/CustomSelect.jsx";
import CustomDatePicker from "components/CustomDatePicker/CustomDatePicker.jsx";
import ImageUpload from 'components/CustomUpload/ImageUpload.jsx';

import RichEditor from "components/RichEditor/RichEditor.jsx";

import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import {  CardContent, CardActions } from "@material-ui/core";

import modalStyle from "assets/jss/material-dashboard-pro-react/modalStyle.jsx";

//import { alert, store, plugins } from 'helpers';
import { earnSpecialsConstants,surveyConstants } from '../../constants';
import { surveyAction, memberActions } from 'actions';
import * as FormValidator from './validate/FormValidator';

// Condition
import FormPoint from "./FormCondition/FormPoint.jsx";

// Reward
import FormRewardPoint from "./FormReward/FormRewardPoint.jsx";
import Form3rdPartyCode from "./FormReward/Form3rdPartyCode.jsx";

// material jss
import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";

import TagsMultiSelect from "components/CustomSelect/TagsMultiSelect.jsx";
import i18n from "i18n";

const FORM_NAME = "FORM_EARNSPECIALS";
const dbDateFormat = "YYYY-MM-DDTHH:mm:ss.sssZ";


const validate = (values) => {

    const errors = crmValidator.validateByRulesList(FormValidator.form_survey_validate, values);
    return errors

}

const style = {
	customCardContentClass: {
		paddingLeft: "0",
		paddingRight: "0",
	},
	cardIconTitle: {
		...cardTitle,
		marginTop: "15px",
		marginBottom: "0px",
	},
	cardFooter: {
		padding: "15px",
		textAlign: "right",
		paddingTop: "0",
		margin: "0",
	},
	labelHorizontalCenter: {
		float: "right",
		color: "rgba(0, 0, 0, 0.26)",
		cursor: "pointer",
		display: "inline-flex",
		fontSize: "14px",
		lineHeight: "1.428571429",
		fontWeight: "400",
		paddingTop: "39px",
		marginRight: "0",
	},
	checkboxAndRadio: {
		position: "relative",
		display: "block",
		marginTop: "10px",
		marginBottom: "10px",
	},
	checkboxAndRadioHorizontal: {
		position: "relative",
		display: "block",
		"&:first-child": {
			marginTop: "10px",
		},
		"&:not(:first-child)": {
			marginTop: "-14px",
		},
		marginTop: "0",
		marginBottom: "0",
	},
	paddingLeft32: {
		paddingLeft: "32px",
	},
	borderDashed: {
		border: "dashed 1px rgb(119 116 116)",
		padding: "20px 20px",
		width: "100%",
		margin: "15px 15px",
	},
};

const validMimeType = "image/jpeg, image/png";
const validateImageFormat = imageFile => {
  if (imageFile) {
    if (!validMimeType.includes(imageFile.type)) {
      return `Allow file type .jpeg or .png only `;
    }
  }
}

const validateRequiredImage = imageFile => {
    if (imageFile === null || imageFile === undefined || imageFile === "") {
      return "Survey Image is required"
    }
  }
  const NotValidateRequiredImage = imageFile => {
    return "";
  }

  const validateImageSize = imageFile => {
    if (imageFile) {
      if (imageFile.size > (1048576 * 2)) {
        return `Banner picture file size must be less than 2MB`
      }
    }
  }

class CreateSurveyForm extends React.Component {

    handleSubmit = (values) => {
		const { dispatch,initialId } = this.props;

         console.log("handleSubmit data: ",data)

        let data = lodash.clone(values) 
        
        data._id = initialId

		if (data.startDate) {
			data.startDate = moment(data.startDate).format(dbDateFormat);
		}

		if (data.endDate) {
			data.endDate = moment(data.endDate).format(dbDateFormat);
		}

        if(data.surveyImage){
            data.file = data.surveyImage
            delete data.surveyImage
        }

        if(data.thankImage){
            data.fileThank = data.thankImage
            delete data.thankImage
        }
        
        if (!data.condition) {
            data.condition = ""; // Assign an empty string if there's no value
        } else {
            data.condition = btoa(encodeURIComponent(data.condition));
        }

       
		if (this.props.formMode === "add") {
             console.log('data:',data);

            dispatch(surveyAction.addSurvey(data));
		} else {
			dispatch(surveyAction.updateSurvey(data));
		}

	};

   

    componentDidMount() {
        const { dispatch, FORM_EARNSPECIALS }  = this.props;

        dispatch(memberActions.getActiveTagList());
		dispatch(memberActions.getActiveMemberLevelList());

    }
    render() {
        const { formOpen, formMode, classes, dispatch, handleSubmit, FORM_EARNSPECIALS, trdPartyCodeSet, formMemberLevellist, formTaglist, surveyImagePreview, thankImagePreview,  initialId, readOnlySurvey } = this.props

        let { readOnly } = this.props

        if (formMode === `add`) {
            readOnly = false
        } else if (formMode === 'edit') {
            readOnly = (readOnlySurvey) ? true : false;
        } else {
            readOnly = true
        }

        let componentReward = null;
        let selTrdPartyValue = [];

        if (lodash.has(FORM_EARNSPECIALS, "values.rewardType")) {
			if (FORM_EARNSPECIALS.values.rewardType === "3rdPartyCode") {
				if (formMode === "add") {
					lodash.forEach(trdPartyCodeSet, function (value, key) {
						if (!value.useInCampaignId) {
							let sel_value = value._id;
							let sel_label = `${value.setName} (${value.useable}/${value.total
								})`;
							selTrdPartyValue.push({
								value: sel_value,
								label: sel_label,
							});
						}
					});
				} else if (formMode === "edit" && !lodash.isEmpty(trdPartyCodeSet)) {
					selTrdPartyValue = [
						{
							value: FORM_EARNSPECIALS.values.trdPartyCodeSetId,
							label: trdPartyCodeSet.setName,
						},
					];
				}

				componentReward = (
					<Form3rdPartyCode
						props={this.props}
						selTrdPartyValue={selTrdPartyValue}
						FORM_NAME={FORM_NAME}
					/>
				);
			} else if (FORM_EARNSPECIALS.values.rewardType === "point") {
				componentReward = (
					<FormRewardPoint props={this.props} FORM_NAME={FORM_NAME} />
				);
			} 

		}

        return (
        
            <Card className={classes.card}>
                <CardHeader
                    title={
                        <h4 className={classes.modalTitle}>
                            <b>{formMode === 'add' ? 'Create Survey' : (readOnly ? 'Special Info' : 'Edit Survey')}</b>
                        </h4>
                    }
                    className={classes.modalHeader}
                />
                <form name={FORM_NAME} onSubmit={handleSubmit(this.handleSubmit)}>
                    <CardContent className={classes.cardContent}>

                        <GridContainer>
                            <GridItem xs={12} sm={6} md={8}>
                                <Field
                                    id='special-name-input'
                                    name="name"
                                    component={CustomInput}
                                    type="text"
                                    labelText="Topic Name *"
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    disabled={readOnly}
                                />
                                {formMode === "edit" ?
                                    <Field
                                        id='special-id-survey-input'
                                        name="_idSurvey"
                                        component="input"
                                        type="hidden"
                                        parse={(value) => value || initialId} // Assign _id to _idSurvey
                                    />
                                    : null}
                            </GridItem>
                        </GridContainer>

                        <GridContainer>
                            <GridItem xs={12} sm={6} md={8}>
                                <Field
                                    id='tagline-input'
                                    name="tagline"
                                    component={CustomInput}
                                    type="text"
                                    labelText="Short Description *"
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    disabled={readOnly}
                                />                              
                            </GridItem>
                        </GridContainer>

                        <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                                <Field
                                    name="surveyImage"
                                    component={ImageUpload}
                                    type="text"
                                    labelText="Survey Image"
                                    textCenter={true}
                                    width={(1140 / 2.5)}
                                    height={(400 / 2.5)}
                                    showRatioGuide={true}
                                    recommendWidth={1140}
                                    recommendHeight={400}
                                    onChange={(e) => {
                                    e.preventDefault();
                                    let reader = new FileReader();
                                    let file = e.target.files[0];
                                    reader.onloadend = () => {
                                        dispatch({ type: surveyConstants.SET_FORM_PREVIEW_IMAGE, surveyImagePreview: reader.result })
                                    };
                                    try {
                                        if (!validMimeType.includes(file.type)) {
                                        dispatch(touch(FORM_NAME, 'surveyImage'));
                                        }
                                        reader.readAsDataURL(file);
                                        dispatch(change(FORM_NAME, 'surveyImage', file))
                                    } catch (error) {
                                        dispatch({ type: surveyConstants.SET_FORM_PREVIEW_IMAGE, surveyImagePreview: "default" })
                                        dispatch(change(FORM_NAME, 'surveyImage', ''))
                                    }
                                    }}
                                    imagePreviewUrl={surveyImagePreview}
                                    formControlProps={{
                                    fullWidth: true
                                    }}
                                    validate={[
                                    validateImageFormat,
                                    (formMode === "add" ? validateRequiredImage : NotValidateRequiredImage),
                                    validateImageSize
                                    ]}
                                    disabled={readOnly}
                                />
                            </GridItem>
                        </GridContainer>    

                        {/* <GridContainer>
                            <GridItem xs={12} sm={6} md={8}>
                                <Field
                                    id='earn-point'
                                    name="earnPoint"
                                    component={CustomInput}
                                    type="text"
                                    labelText="Given Points"
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    disabled={readOnly}
                                />                              
                            </GridItem>
                        </GridContainer> */}

                        <GridContainer>
                            <GridItem xs={12} sm={4} md={4}>
                                <Field
                                    id='start-date-select'
                                    name="startDate"
                                    component={CustomDatePicker}
                                    type="text"
                                    maxDate={FORM_EARNSPECIALS.values?.endDate || null}
                                    labelText="Start Date *"
                                    dateFormat="DD-MMM-YY"
                                    timeFormat="HH:mm"
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    disabled={readOnly}
                                />
                            </GridItem>
                            <GridItem xs={12} sm={4} md={4}>
                                <Field
                                    id='end-date-select'
                                    name="endDate"
                                    minDate={FORM_EARNSPECIALS.values?.startDate || null} 
                                    component={CustomDatePicker}
                                    type="text"
                                    labelText="End Date"
                                    dateFormat="DD-MMM-YY"
                                    timeFormat="HH:mm"
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    disabled={false}
                                />
                            </GridItem>     
                        </GridContainer>

                        <GridContainer>
                            
                            <GridItem xs={12} sm={6} md={4}>
                                <Field
                                    id='status-select'
                                    name="status_survey"
                                    component={CustomSelect}
                                    type="text"
                                    labelText="Status *"
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    optionsList={[
                                        {value: "active",label: "Active"},
                                        {value: "inactive",label: "Inactive"},   
                                                                        
                                    ]}
                                    disabled={false}
                                />
                            </GridItem>
                    
                        </GridContainer>                         

                        <GridContainer>
                            <GridItem xs={12} sm={6} md={8}>
                                <Field
                                    id='max-answer-times-input'
                                    name="maxAnswerTimes"
                                    component={CustomInput}
                                    type="text"
                                    labelText="Max Answer Times *"
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    disabled={readOnly}
                                />                              
                            </GridItem>
                        </GridContainer>

                        <GridContainer>
                            <GridItem xs={12} sm={6} md={8}>
                                <Field
                                    id='thank-message-input'
                                    name="thankMessage"
                                    component={CustomInput}
                                    type="text"
                                    labelText="Thank You Message *"
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    disabled={readOnly}
                                />                              
                            </GridItem>
                        </GridContainer>

                        <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                                <Field
                                    name="thankImage"
                                    component={ImageUpload}
                                    type="text"
                                    labelText="Complete Survey Image"
                                    textCenter={true}
                                    width={(1140 / 2.5)}
                                    height={(400 / 2.5)}
                                    showRatioGuide={true}
                                    recommendWidth={1140}
                                    recommendHeight={400}
                                    onChange={(e) => {
                                    e.preventDefault();
                                    let reader = new FileReader();
                                    let fileThank = e.target.files[0];
                                    reader.onloadend = () => {
                                        dispatch({ type: surveyConstants.SET_FORM_PREVIEW_IMAGE_THANK, thankImagePreview: reader.result })
                                    };
                                    try {
                                        if (!validMimeType.includes(fileThank.type)) {
                                        dispatch(touch(FORM_NAME, 'thankImage'));
                                        }
                                        reader.readAsDataURL(fileThank);
                                        dispatch(change(FORM_NAME, 'thankImage', fileThank))
                                    } catch (error) {
                                        dispatch({ type: surveyConstants.SET_FORM_PREVIEW_IMAGE_THANK, thankImagePreview: "default" })
                                        dispatch(change(FORM_NAME, 'thankImage', ''))
                                    }
                                    }}
                                    imagePreviewUrl={thankImagePreview}
                                    formControlProps={{
                                    fullWidth: true
                                    }}
                                    validate={[
                                    validateImageFormat,
                                    NotValidateRequiredImage,
                                    //(formMode === "add" ? validateRequiredImage : NotValidateRequiredImage),
                                    validateImageSize
                                    ]}
                                    disabled={readOnly}
                                />
                            </GridItem>
                        </GridContainer> 

                        <GridContainer>
                            <GridItem xs={12} sm={6} md={8}>
                                <Field
                                    id='detail-input'
                                    name="detail"
                                    component={CustomInput}
                                    type="text"
                                    labelText="Detail *"
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    disabled={readOnly}
                                />                              
                            </GridItem>
                        </GridContainer>

                        <GridContainer>
                            
                            <GridItem xs={12} sm={12} md={12}>
                                <Field
                                    name="condition"
                                    component={RichEditor}
                                    labelText="Terms & Conditions"
                                    disabled={readOnly}
                                />
						    </GridItem>    
                            
                        </GridContainer>

                        

                        

            </CardContent>

            <GridContainer>
                <GridItem xs={12} sm={12} md={12} style={{ marginTop: "20px" }}>
                    
                        <Button
                            id='submit-btn'
                            type="submit"
                            color="primary"
                            style={{ marginRight: "10px" }}
                        >
                            {formMode === "edit" ? "Update" : "Submit"}
                        </Button>
                    
                    <Button
                        id='close-btn'
                        type="button"
                        onClick={() => {
                            dispatch({ type: surveyConstants.CLOSE_FORM_SURVEY });
                            this.props.onClose();
                        }}
                        style={{ marginLeft: readOnly ? "0px" : "10px" }}
                        color="white"
                    >
                        Close
                    </Button>
                </GridItem>
            </GridContainer>
            </form>
            </Card>
        )
    }

}

function mapStateToProps(state) {
    const { formOpen, formMode, productList, allProductList, joinedProductRows, joinedProductList, allShopListSelected, productListMaster,trdPartyCodeSet, rewardImagePreview, surveyImagePreview, thankImagePreview } = state.survey;
    const { FORM_EARNSPECIALS } = state.form;
    const { formTaglist, formMemberLevellist } = state.member;
    const { package_features } = state.authentication
    return {
        formOpen, formMode, FORM_EARNSPECIALS, allProductList, productList, joinedProductRows, joinedProductList, allShopListSelected, productListMaster, package_features, trdPartyCodeSet, formTaglist, formMemberLevellist, rewardImagePreview, surveyImagePreview, thankImagePreview
    };
}

const connectCampaignForm = connect(mapStateToProps)(CreateSurveyForm);

export default reduxForm({
    form: FORM_NAME,
    validate: validate,
    enableReinitialize: true,
    onSubmitFail: (errors, dispatch, props) => {

       
    }
})(withStyles(modalStyle)(connectCampaignForm))
